<template>
    <main>
        <div class="row">

            <div class="col-sm-12" v-if="mostrarCampos && !hasDisabled">
                <form-create v-if="dialogCreate" :colaborador-id="colaboradorId" :escola-id="escolaId" @on-saved="onSaved()" @on-back="hideAll()" />
            </div>
            
            <div class="col-sm-12" id="div-colaborador-escola-cargo">

                <div class="table-responsive standard-table header-cinza">
                    <table>
                        <thead>
                            <tr>
                                <th>Ordem</th>
                                <th>Escola</th>
                                <th>Cargo</th>
                                <!--<th>Nível Profissional</th>-->
                                <th v-if="!hasDisabled" class="text-center" width="150"><i class="fa fa-cog"></i></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="item in result.items" v-bind:key="item.cargoId" class="animated fadeIn">
                                <td>{{ item.ordem }}</td>
                                <td>{{ item.escola.nomeEscola }}</td>
                                <td>{{ item.cargo.nmCargo }}</td>
                                <!--<td>
                            <select :disabled="hasDisabled" v-select="{ dataitem: 'AuxNivelProfissional', default: 'Selecione' }" v-model="item.nivelProfissionalId" class="form-control" @change="openSituacaoColaboradorEscola(item)" name="nivelProfissionalId" required></select>
                        </td>-->
                                <td class="text-center" v-if="!hasDisabled">
                                    <button type="button" class="btn btn-sm btn-danger" v-b-tooltip title="Demitir" @click="openRemove(item)">
                                        <i class="fa fa-times-circle"></i>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>

            </div>
        </div>

        <br />

        <div class="col-sm-12 alert alert-danger" v-if="isModal && dialogRemove">
            <p class="text-center" v-if="model && model.cargo">Remover <strong>{{ model.cargo.nmCargo }}</strong></p>
            <p>Esse procedimento é irreversível, e somente após um novo processo seletivo este colaborador poderá ganhar este cargo novamente.</p>
            <p>Tem certeza que deseja demitir o colaborador deste cargo?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </div>

        <b-modal v-if="!isModal" :no-close-on-backdrop="true" :no-close-on-esc="true" centered v-model="dialogRemove" title="Confirmação">
            <p v-if="model && model.cargo">Remover <strong>{{ model.cargo.nmCargo }}</strong></p>
            <p>Esse procedimento é irreversível, e somente após um novo processo seletivo este colaborador poderá ganhar este cargo novamente.</p>
            <p>Tem certeza que deseja demitir o colaborador deste cargo?</p>
            <div slot="modal-footer">
                <button class="btn btn-sm btn-danger" @click="executeRemove()">
                    Remover
                </button>
            </div>
        </b-modal>

    </main>


</template>
<script>

    import base from '@/common/base.js'
    import { Api } from '@/common/api'
    import formCreate from './form-create'

    export default {
        name: 'colaboradorescolacargo',
        mixins: [base],
        props: { colaboradorId: Number, escolaId: Number, hasDisabled: Boolean, mostrarCampos: Boolean, isModal: Boolean },
        components: { formCreate },
        data() {
            return {

                resources: {
                    filter: 'colaboradorescolacargo',
                    remove: 'colaboradorescolacargo'
                },

                dialogRemove: false,
                dialogCreate: true,

                model: {},
                filter: {
                    pageSize: 50,
                    pageIndex: 1,
                    isPagination: true,
                },

                result: {
                    total: 0,
                    items: []
                }
            }
        },
        methods: {

            openSituacaoColaboradorEscola: function (item) {

                this.model = item;
                this.model.attributeBehavior = "AlterarNivelProfissional";

                new Api('colaboradorescolacargo').post({
                    attributeBehavior: "AlterarNivelProfissional",
                    cargoId: item.cargoId,
                    colaboradorId: item.colaboradorId,
                    escolaId: item.escolaId,
                    nivelProfissionalId: item.nivelProfissionalId,
                }).then(() => {
                    this.defaultSuccessResult("Nível profissional atualizado com sucesso.");
                    this.model = null;
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            openCreate: function () {
                this.dialogCreate = true;
            },
            onSaved: function () {
                this.hideAll();
                this.executeLoad();
            },
            hideAll: function () {
                this.dialogRemove = false;
                this.dialogCreate = false;
                setTimeout(() => {
                    this.dialogCreate = true;
                }, 100)
            },

            openRemove: function (model) {
                this.model = model;
                this.dialogRemove = true;
            },
            executeRemove: function (model) {
                if (model) this.model = model;
                new Api(this.resources.remove).delete(this.model).then(() => {
                    this.dialogRemove = false
                    this.defaultSuccessResult("Item removido com sucesso");
                    this.executeLoad();
                    if (this.result.items.length > 0) this.$emit('on-back')
                }, err => {
                    this.defaultErrorResult(err);
                })
            },

            executeLoad: function () {
                this.showLoading();

                this.filter.colaboradorId = this.colaboradorId;
                this.filter.escolaId = this.escolaId;
                new Api(this.resources.filter).get(this.filter).then(data => {
                    if (data.summary) this.result.total = data.summary.total;
                    this.result.items = data.dataList;
                    this.hideLoading();
                }, (err) => {
                    this.failLoading();
                    if (err && err.data && err.data.errors) {
                        this.$eventHub.$emit('show-notification', {
                            type: 'error',
                            title: 'Atenção',
                            text: err.data.errors[0]
                        })
                    }
                });

            },

        },

        mounted() {
            this.filter = this.defaultOrderBy(this.filter, 'ordem');
            this.executeLoad();
        }

    };
</script>